<template>
  <div class='index-container'>
    <el-header>
      <Logo :isCollapse='isCollapse' />
      <TagsView class='tags' />
      <LoginOut />
    </el-header>
    <el-aside style='width: auto;'>
      <div class='inner-container' :class="!isType ? 'height100' : ''">
        <asideBar :collapse='isCollapse' ref='asi'></asideBar>
      </div>
      <RangePage v-if='isType' :isCollapse='isCollapse' />
    </el-aside>
    <el-main :class="!isCollapse ? 'l250' : 'l65'">
      <div class='tools' @click='toggleClick'>
        <i :class='icon'></i>
      </div>
      <section @mouseenter='handleEnter' class='shortcut_menu'>
        <i class='iconfont icon-kuaijiecaidan' style='color:white'></i>
      </section>
      <div @mouseenter='handleEnter' @mouseleave='mouseleaveFn($event)' class='shortcut_bool' v-show='showBar'>
        <div class='shortcut-grid'>
          <!-- 先渲染快捷菜单的固定图标 -->
          <div class='shortcut-item' v-for='(item, index) in quickArr' :key='index' @click='skipPath(item)'>
            <i :class='item.icon'></i>
            <span class='shortcut-name'>{{ generateTitle(item) }}</span>
          </div>

          <div class='shortcut-item' v-for='item in right_arr' :key='item.id' @click='skipPath(item)'>
            <i :class='item.icon'></i>
            <span class='shortcut-name'>{{ generateTitle(item) }}</span>
          </div>
        </div>
      </div>
      <el-card>
        <appMain></appMain>
      </el-card>
    </el-main>
    <div class='footer uk-flex uk-flex-middle'>
      <span class="fm-foot-rights">{{$t('public.footer_rights')}}</span>
      <span class="fm-foot-sep">·</span>
      <span class="fm-foot-addr">{{$t('public.footer_address')}}</span>
      <span class="fm-foot-sep">·</span>
      <a class="fm-foot-link" :href="termsUrl" target="_blank" rel="noopener noreferrer">{{$t('public.footer_terms')}}</a>
      <span class="fm-foot-sep">|</span>
      <a class="fm-foot-link" :href="privacyUrl" target="_blank" rel="noopener noreferrer">{{$t('public.footer_privacy')}}</a>
    </div>

    <!-- 用slice去掉添加图标 -->
    <shortCutBarDialog v-if='quickBarShow' :scDialogShow.sync='quickBarShow' :quickMenu.sync='right_arr'>
    </shortCutBarDialog>
  </div>
</template>

<script>
import Cert from './Cert.vue'
import Logo from '@/components/logo/index'
import TagsView from '@/components/TagsView/index'
import asideBar from '@/components/Menu/index'
import appMain from './appMain'
import LoginOut from '@/components/loginout/index.vue'
import shortCutBarDialog from './component/shortCutBarDialog.vue'
import { getShortCut } from '@/api/modules/shortCut.js'
import { downloadProgress } from '@/api/modules/download.js'
import bus from '@/utils/bus.js'
import { getIsGuide } from '@/utils/guide'
import { guideStep } from '@/common/driver/driver'
import { generateTitle } from '@/utils/i18n'

export default {
  components: {
    Logo,
    LoginOut,
    TagsView,
    asideBar,
    appMain,
    shortCutBarDialog,
    Cert
  },
  computed: {
    i18n () {
      return this.$i18n.locale
    },
    icon: function () {
      return this.isCollapse ? 'el-icon-right' : 'el-icon-back'
    },
    isType () {
      // 是否是代理角色
      return false
    },
    listIds () {
      return this.$store.state.downLoad.listids
    }
  },
  watch: {
    listIds (newVal) {
      clearInterval(this.timer)
      this.downLoad()
    }
  },
  data () {
    return {
      levelList: null,
      isCollapse: false,
      screenWidth: '',
      num: 0,
      flag: true,
      flags: false,
      isBool: false,
      Menus: '',
      choozeMenus: {},
      tagNum: 0,
      // 快捷菜单栏
      right_arr: [],
      quickArr: [
        {
          id: -1,
          name: '',
          icon: 'el-icon-circle-plus-outline',
          path: '',
          code: 'addShortcutbar'
        }
      ],
      showBar: false, // 快捷栏列的显影
      quickBarShow: false, // 快捷栏窗口
      quickBarTitle: '',
      quickBarDialogWidth: '600px',
      height: '440px',
      left_arr: [],
      dom: null, // 实现拖拽

      timer: null,
      notifyPromise: Promise.resolve(),
      // 隐私政策 / 使用条款 URL（与登录页注册弹框 registyDia.vue 同一地址）
      privacyUrl: 'https://www.vm-iot.com/privacy_policy.html',
      termsUrl: 'https://www.vm-iot.com/user_agreement.html'
    }
  },
  created () {
    this.$loading.hide()
  },
  methods: {
    generateTitle,
    // 为生成文件成功绑定事件
    bindMsgEvent () {
      const fileGenerateSuccess = document.getElementsByClassName('file-generate-success')
      for (let i = 0; i < fileGenerateSuccess.length; i++) {
        fileGenerateSuccess[i].onclick = () => {
          // 子窗口的parent是父窗口 而父窗口的parent还是自己  由此可以判断当前是否为父窗口 如果是父窗口才进行push
          console.log(window.frames.length, parent.frames.length)
          if (window.frames.length === parent.frames.length) {
            this.$router.push({
              path: '/download'
            })
          }
        }
      }
    },
    handleEnter () {
      this.showBar = true
    },
    mouseleaveFn () {
      this.showBar = false
    },
    skipPath (arg) {
      if (arg.id === -1) {
        // this.right_arr = this.left_arr = this.templayteData.quick_bar
        // this.defaultCheckedKeys = this.templayteData.quick_bar
        //   ? this.templayteData.quick_bar.map((item) => {
        //     return item.id
        //   })
        //   : []
        this.quickBarShow = true
      } else {
        this.$router.push(arg.url)
      }
    },

    getBreadcrumb () {
      // $route.matched一个数组 包含当前路由的所有嵌套路径片段的路由记录
      const matched = this.$route.matched.filter(item => item.name)
      this.levelList = matched
    },

    toggleClick () {
      this.isCollapse = !this.isCollapse
      bus._collapse_ = this.isCollapse
      // 通过bus这个中介里面的$emit去触发自定义事件， $emit($t('integration.custom_event_name'), 参数)
      bus.$emit('collapse', this.isCollapse)
    },

    initShortCut () {
      getShortCut().then(({ result }) => {
        this.right_arr = result
      })
    },

    async downLoad () {
      this.timer = setInterval(() => {
        if (this.$store.state.downLoad.listids.length === 0) return
        downloadProgress(this.$store.state.downLoad.listids)
          .then(res => {
            if (res.result.length === 0 || res.state.code !== 200) {
              clearInterval(this.timer)
              return
            }
            res.result.forEach(item => {
              // 为真则证明是下载完成 进行提示 并且删除对应的id
              if (item.end) {
                this.$store.state.downLoad.listids = this.$store.state.downLoad.listids.filter(opt => opt !== item.key)
                // 通知下载页面刷新列表
                bus.$emit('downloadComplete')
                this.notifyPromise = this.notifyPromise.then(() => {
                  const type = item.downloadRecord.status === 1 ? 'success' : 'error'
                  const title = item.downloadRecord.status === 1 ? $t('integration.success') : $t($t('integration.fail'))
                  this.$notify({
                    title,
                    dangerouslyUseHTMLString: true,
                    message: `<div class='cursor-pointer pr-5' style='text-align:left;word-wrap: anywhere;'>${item.downloadRecord.name}生成${title}${item.downloadRecord.status === 1 ? $t('integration.click_to_jump_to_the_download_page_for_download') : ''}</div>`,
                    type,
                    customClass: 'file-generate-success'
                  })
                  // 为自定义类名绑定点击事件
                  this.bindMsgEvent()
                })
              }
            })
          })
          .catch(() => {
            clearInterval(this.timer)
          })
      }, 1000)
    }
  },
  mounted () {
    this.initShortCut()
    this.downLoad()
    this.$nextTick(() => {
      if (getIsGuide() && this.$route.name === 'Home') {
        // 需要等所有节点都渲染完成
        setTimeout(() => {
          guideStep()
        }, 500)
      }
    })
  },
  destroyed () {
    clearInterval(this.timer)
  }
}
</script>

<style lang='scss' scoped>
@import '@/styles/public.scss';

.index-container {
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
  position: relative;
  min-width: 1280px;
  min-height: 937px;
  overflow: auto;
}

//顶部
::v-deep .el-header {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 40px !important;
  background: var(--primary-color);
  display: flex;
  justify-content: space-between;

  .tags {
    flex: 1;
  }

  .el-dropdown {
    color: #0e0c0a;
    font-size: 14px;
  }
}

// 侧边
.el-aside {
  position: absolute;
  top: 40px;
  bottom: 40px;
  left: 0;
  color: #253446;
  overflow-x: hidden;
}

::v-deep .el-scrollbar__wrap {
  overflow: hidden;
  overflow-x: hidden !important;
  margin: 0 !important;
  padding-right: 10px;
}

.inner-container {
  height: 95%;
  background-color: #f3f3f3;

  ::v-deep .el-scrollbar__view {
    i {
      font-size: 20px;
    }
  }
}

.height100 {
  height: 100%;
}

.inner-container::-webkit-scrollbar {
  display: none;
}

.el-main {
  position: absolute;
  top: 40px;
  left: 250px;
  bottom: 40px;
  right: 0px;
  transition: all 0.5s ease-in-out;
  background-color: #e5e5e5;
  padding: 10px 20px;
  box-sizing: border-box;
  border: none;
  overflow: auto;

  .el-card {
    border: none;
    height: 100%;
    width: 100%;
    overflow: auto;
    overflow-x: hidden;
  }
}

.l250 {
  left: 250px;
}

.l65 {
  left: 40px;
}

.tools {
  cursor: pointer;
  position: absolute;
  height: 50px;
  line-height: 50px;
  top: 50%;
  bottom: 50%;
  left: -5px;

  z-index: 8;
  transform: translate(50%, -100%);
  background-color: var(--primary-color);

  i {
    color: #fff;
  }
}

.shortcut_menu {
  position: fixed;
  height: 50px;
  line-height: 50px;
  top: 50%;
  bottom: 50%;
  width: 16px;
  right: 10px;
  background-color: var(--primary-color);
  transition: none;
  transform: translate(50%, -50%);
  z-index: 999;
}

.shortcut_bool {
  position: fixed;
  width: 240px;
  max-height: 80vh;
  top: 50%;
  right: 18px;
  padding: 10px;
  background-color: var(--primary-color);
  transition: none;
  transform: translateY(-50%);
  text-align: center;
  z-index: 9999;
  overflow: auto;

  .shortcut-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
  }

  .shortcut-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 8px 4px;
    cursor: pointer;
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 4px;
    transition: all 0.3s;

    &:hover {
      border-color: #ffffff;
      background-color: rgba(255, 255, 255, 0.15);
    }

    i {
      font-size: 28px;
      color: #ffffff;
      margin-bottom: 4px;
    }

    .shortcut-name {
      font-size: 12px;
      color: #ffffff;
      text-align: center;
      word-break: break-all;
      line-height: 1.2;
      max-width: 70px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
}

.shortcut_bool::-webkit-scrollbar {
  display: none;
}

::v-deep .el-card__body {
  padding: 0 !important;
  height: 100%;
  box-sizing: border-box;
  background-color: #ffffff;
}

// ::v-deep.el-card {
//   min-width: 1280px;
//   // min-height: 1080px;
//   overflow: auto;
// }
.dropdown {
  li:hover {
    background-color: #c2c2c2;
    color: #fff;
  }

  img {
    width: 20px;
    height: 20px;
    display: inline-block;
    margin-top: 4px;
  }

  .active {
    background-color: #c2c2c2;
  }
}

::v-deep .el-icon-right {
  color: #fff;
}

::v-deep .el-tabs--left {
  height: 100%;
}

::v-deep .el-tabs__content {
  height: 100%;
}

::v-deep .el-tabs__active-bar {
  background-color: var(--primary-color);
}

::v-deep .el-tabs__item.is-active {
  color: var(--primary-color);
}

::v-deep .el-tabs__item:hover {
  color: var(--primary-color);
}

// 快捷栏
.section {
  width: 100%;
  height: 400px;
}

.selectBar {
  width: 100%;
  height: 400px;
  display: flex;
  justify-content: space-between;

  // margin-bottom: 20px;
  .left_menu {
    flex: 1;
    height: 100%;
    overflow: auto;

    p {
      height: 24px;
      line-height: 24px;
      font-size: 16px;
      text-align: center;
      color: var(--primary-color);
      border: 1px solid #eee;
      box-sizing: border-box;
    }

    .ztree {
      height: calc(100% - 24px);
    }
  }

  .center_menu,
  .right_menu {
    width: 100px;
    height: 100%;

    p {
      height: 24px;
      line-height: 24px;
      font-size: 16px;
      text-align: center;
      color: var(--primary-color);
      box-sizing: border-box;
      border-bottom: 1px solid #eee;
    }
  }

  .center_menu {
    width: 150px;
    display: flex;
    justify-content: center;
    align-items: center;

    i {
      color: #000000;
      font-size: 28px;
      cursor: pointer;
      transform: rotate(90deg);
    }
  }

  .right_menu {
    border: 1px solid #eee;
    text-align: center;
    overflow: auto;
    height: calc(100% - 24px);

    span {
      margin: 0 auto;
      width: 50px;
      height: 50px;
      display: block;
      margin-top: 10px;
      text-align: center;
      position: relative;
    }

    i {
      display: block;
      color: var(--primary-color);
      font-size: 36px;
      cursor: pointer;
      line-height: 50px;
    }

    .close {
      position: absolute;
      top: -5px;
      right: 0px;
      width: 14px;
      height: 14px;
      display: inline-block;
      border-radius: 50%;
      color: var(--primary-color);
      font-size: 14px;
      cursor: pointer;
    }

    .close:hover {
      color: red;
    }
  }
}

.footer {
  position: absolute;
  bottom: 0;
  background-color: var(--primary-color);
  color: white;
  width: 100%;
  box-sizing: border-box;
  height: 40px;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  gap: 8px;
  font-size: 12px;
  flex-wrap: nowrap;
  overflow: hidden;

  .fm-foot-sep {
    opacity: 0.5;
  }

  .fm-foot-link {
    color: rgba(255, 255, 255, 0.85);
    text-decoration: none;
    transition: color 0.2s ease;

    &:hover {
      color: #ffffff;
      text-decoration: underline;
    }
  }
}
</style>
